<template>
<form class="form-inline" @submit.prevent="submit" v-if="box">
  <div class="input-group input-group-sm">
    <div class="input-group-prepend">
      <button class="btn btn-outline-info dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        {{ box.field === 'office' ? labels[shared.lang].company : labels[shared.lang].name }}
      </button>
      <div class="dropdown-menu">
        <a class="dropdown-item" v-text="labels[shared.lang].name" @click.prevent="changeField('name')"></a>
        <a class="dropdown-item" v-text="labels[shared.lang].company" @click.prevent="changeField('office')"></a>
      </div>
    </div>
    <input class="form-control" type="search" :placeholder="labels[shared.lang].keyword" aria-label="Search" v-model.trim="box.keyword">
    <div class="input-group-append">
      <button class="btn btn-info" type="submit" v-text="labels[shared.lang].search"></button>
    </div>
  </div>
</form>
</template>

<script>
'use strict'
import { labels } from '../label.js'
import { shared } from '../state.js'
export default {
  name: 'HomeSearchBox',
  props: ['field', 'keyword'],
  data() {
    return {
      labels: labels,
      shared: shared,
      
      box: {
        field: this.field || 'name',
        keyword: this.keyword || '',
      },
    }
  },
  created() {
    this.$root.$on('global-search-keyword', this.changeName)
  },
  beforeDestory() {
    this.$root.$off('global-search-keyword', this.changeName)
  },
  methods: {
    changeName(keyword) {
      this.box.field = 'name'
      this.box.keyword = keyword
    },
    changeField(value) {
      this.box.field = value
    },
    submit() {
      this.$emit('search', this.box)
    },
  },
}
</script>

<style scoped>

</style>
